const routes = {
  home: {
    path: "/",
  }
};

export default routes;